import { useCallback, useMemo } from 'react';
import { noop } from 'lodash-es';
import { useStateInRef } from 'seagull';
import { useClientContactModals } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/hooks/useClientContactModals';
import { useContactsMap } from '~/hooks/reactQuery/derived/useContactsMap';
import { useClientContacts } from '~/hooks/reactQuery/queries/useClientContacts';
import { useClients } from '~/hooks/reactQuery/queries/useClients';
import { useGetDraftContact } from '../../../../hooks/useGetDraftContact';
import { draftClientId } from '../../../draftClient.utils';
export function useClientAdditionalRecipients(draft, setDraft) {
    const getDraft = useStateInRef(draft);
    const legacyPrimaryContact = useGetDraftContact(draft);
    const clientId = draftClientId(draft, legacyPrimaryContact);
    const { clients } = useClients();
    const { fetchContacts: refreshAllContacts } = useContactsMap();
    const { contacts: clientContacts, isLoading, refresh: refreshClientContacts } = useClientContacts(clientId, {
        enabled: clientId != null,
        refreshOnHookMount: true
    });
    const primaryContact = useMemo(()=>{
        var _clientContacts_find;
        return (_clientContacts_find = clientContacts.find((contact)=>contact.id() === draft.clientContactId())) !== null && _clientContacts_find !== void 0 ? _clientContacts_find : null;
    }, [
        clientContacts,
        draft
    ]);
    const onChange = useCallback((reviewers)=>setDraft(getDraft().setReviewers(reviewers)), [
        setDraft
    ]);
    const refreshContacts = useCallback(()=>Promise.all([
            refreshClientContacts({
                throwOnError: false
            }),
            refreshAllContacts({
                throwOnError: false
            })
        ]), [
        refreshClientContacts,
        refreshAllContacts
    ]);
    const { onCreateContact: openCreateContactModal } = useClientContactModals({
        clients,
        selectedClientId: clientId,
        onClientCreated: noop,
        refreshContacts
    });
    const onCreateContact = (assign)=>openCreateContactModal(async (contactId)=>{
            const { data } = await refreshClientContacts({
                throwOnError: false
            });
            const created = data === null || data === void 0 ? void 0 : data.find((contact)=>contact.id() === contactId);
            if (created != null) {
                assign(created);
            }
        });
    return {
        clientContacts,
        primaryContact,
        isLoading,
        onChange,
        onCreateContact
    };
}
